/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setup_Unavailable_TitleInputs */

const en_setup_unavailable_title = /** @type {(inputs: Setup_Unavailable_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setup link not valid`)
};

const de_setup_unavailable_title = /** @type {(inputs: Setup_Unavailable_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einrichtungslink ungültig`)
};

/**
* | output |
* | --- |
* | "Setup link not valid" |
*
* @param {Setup_Unavailable_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const setup_unavailable_title = /** @type {((inputs?: Setup_Unavailable_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_Unavailable_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_setup_unavailable_title(inputs)
	return en_setup_unavailable_title(inputs)
});